<template>
  <div class="ActivityGoldAccountDetails">
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="formData"
      @Refresh="onHandleRefresh"
      @search="onHandleSearch"
    >
      <template v-slot:right>
        <el-button
          :disabled="!tableData.length || disabledExport"
          @click="onHandleExport"
          type="warning"
          icon="el-icon-download"
          >导出</el-button
        >
      </template>
    </Filtersearch>

    <!-- 列表 start -->
    <div class="content-wrap">
      <el-table
    :data="tableData"
    height="100%"
    :border="true"
    :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
  >
    <el-table-column type="index" align="center" width="100" label="序号">
    </el-table-column>
    <el-table-column
      prop="username"
      align="center"
      width="100"
      label="用户名"
      show-overflow-tooltip
    >
    </el-table-column>
    <el-table-column prop="mobile" align="center" label="手机号" width="160">
    </el-table-column>
    <el-table-column
      prop="business_name"
      align="center"
      label="集配中心"
      min-width="100"
      show-overflow-tooltip
    >
    </el-table-column>
    <el-table-column
      prop="logistics_name"
      align="center"
      label="城市仓"
      min-width="100"
      show-overflow-tooltip
    >
    </el-table-column>
    <!-- <el-table-column
      prop="deliveryName"
      align="center"
      label="自提点名称"
      min-width="100"
      show-overflow-tooltip
    >
    </el-table-column> -->
    <el-table-column
      prop="major_type_line"
      align="center"
      label="角色"
      min-width="100"
    >
    </el-table-column>
    <el-table-column prop="amount" align="center" label="金额(¥)" width="120">
    </el-table-column>
    <el-table-column
      prop="balance_account"
      align="center"
      label="账户余额(¥)"
      min-width="100"
    >
    </el-table-column>
    <el-table-column
      prop="journal_type_line"
      align="center"
      label="类型明细"
      min-width="100"
    >
    </el-table-column>

    <el-table-column
      prop="remark"
      align="center"
      label="备注"
      min-width="150"
    >
    </el-table-column>
  </el-table>
    </div>
    <!-- 列表 end -->

    <!-- 分页 start -->
    <div class="pagination">
      <el-pagination
        type="primary"
        :current-page="formData.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formData.pageSize"
        :total="total"
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        background
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->

  
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import {
  bitdcrechargeflowexport,
} from "@/api/general/reconciliation-manage/index";
import Filtersearch from "@/components/Filtersearch.vue";

export default {
  name: "ActivityGoldAccountDetails",
  components: {
    Filtersearch,
  },
  data() {
    return {
      Filtersearchlist: [
        {
          type: "select",
          name: "集配中心",
          clearable: true,
          model: "logistics_business_id",
          placeholder: "请选择集配中心",
          selectoptionname: "business_list",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "select",
          name: "城市仓",
          clearable: true,
          filterable: true,
          model: "logistics_id",
          placeholder: "请选择城市仓",
          selectoptionname: "cityStoreList",
          label: "name",
          value: "id",
          selectoption: [],
        },
        // {
        //   type: "select",
        //   name: "自提点",
        //   clearable: true,
        //   filterable: true,
        //   model: "deliveryId",
        //   placeholder: "请选择自提点",
        //   selectoptionname: "selflist",
        //   label: "name",
        //   value: "id",
        //   selectoption: [],
        // },
        {
          type: "input",
          name: "用户名",
          clearable: true,
          model: "username",
          placeholder: "请输入用户名",
        },
        {
          type: "input",
          name: "手机号",
          clearable: true,
          model: "mobile",
          placeholder: "请输入手机号",
        },
       
      ],
      loadingData: false,
      loadingSelfLogisticsList: false,
      disabledExport: false,
      logisticList: [], // 集配中心列表
      cityStoreList: [], // 城市仓列表
      formData: {
        logistics_business_id: "", // 集配中心id
        logistics_id: "", // 城市仓id
        username: "",
        mobile: "",
        page: 1,
        pageSize: 50,
      },
      formDataClone: {}, // 复制一份，用于初始化
      tableData: [],
      total: 0,
      selflist: [],
    };
  },
  watch: {},
  mounted() {
    this.onInitData();
  },
  methods: {
        /**
     * 导出数据（下载中心）
     */
    async onHandleExport() {
      /** 新导出逻辑 */
      this.disabledExport = true;
      const { username } = JSON.parse(sessionStorage.getItem("userInfo"));
      try {
        const query = {
          ...this.formData,
          token: sessionStorage.getItem("token"),
          user_name: username,
        };
        delete query.page;
        delete query.pageSize;
        await bitdcrechargeflowexport(query);
        this.goExportCenter();
      } catch (err) {
        console.log("ajax bitdcrechargeflowexport err", err);
        this.disabledExport = false;
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    // cityChange(val) {
    //   this.Filtersearchlist.forEach((el) => {
    //     if (
    //       el.type == "select" &&
    //       el.selectoptionname &&
    //       el.selectoptionname == "selflist"
    //     ) {
    //       el.selectoption = [];
    //     }
    //   });
    //   this.$refs.Filtersearchref.from.deliveryId = "";
    //   // this.formData.deliveryId = "1";
    //   this.getListData(val);
    // },
    // getListData(val) {
    //   this.$api.general
    //     .deliveryList({
    //       logistics_id: val, //必须填写
    //       page: 1,
    //       pageSize: 1000,
    //     })
    //     .then((res) => {
    //       console.log(res, "获取数据");
    //       this.selflist = res.data.data;
    //       if (res.data.data.length > 0) {
    //         this.Filtersearchlist.forEach((el) => {
    //           if (
    //             el.type == "select" &&
    //             el.selectoptionname &&
    //             el.selectoptionname == "selflist"
    //           ) {
    //             el.selectoption = [{ id: "", name: "全部" }, ...res.data.data];
    //           }
    //         });
    //       }
    //     });
    // },
    /**
     * 初始化数据
     */
    onInitData() {
      this.formDataClone = cloneDeep(this.formData);
      this.ajaxGetTableData();
      this.ajaxGetLogisticList();
      this.ajaxGetCityStoreList();
    },
    /**
     * 获取集配中心列表
     */
    async ajaxGetLogisticList() {
      try {
        const { data } = await this.$api.general.businessList();
        this.logisticList = data;
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "business_list"
          ) {
            el.selectoption = [{ id: "", name: "全部" }, ...data];
          }
        });
      } catch (err) {
        console.log("ajax ajaxGetLogisticList err", err);
      }
    },
    /**
     * 获取城市仓列表
     */
    async ajaxGetCityStoreList() {
      // this.loadingSelfLogisticsList = true;
      const params = {
        name: "",
        page: 1,
        pageSize: 1000,
      };
      try {
        const { data } = await this.$api.general.logisticsList(params);
        this.cityStoreList = data;
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "cityStoreList"
          ) {
            el.selectoption = [{ id: "", name: "全部" }, ...data];
          }
        });
        console.log("ajx ajaxGetCityStoreList", data);
      } catch (err) {
        console.log("ajx ajaxGetCityStoreList err", err);
      } finally {
        // this.loadingSelfLogisticsList = false;
      }
    },
    /**
     * 查询列表数据
     */
    async ajaxGetTableData() {
      this.loadingData = true;
      const params = { ...this.formData };
      try {
         await this.$api.fund.tdcOwnerrechargeflow(params).then(res=>{
            console.log(res,'111111111')
        this.total = res.data.total;
        this.tableData = res.data.list;
         });
        // const { total, data: list } = data;
        // this.total = total;
        // this.tableData = list;
      } catch (err) {
        console.log("ajax postMemberGetCustomerExpenseRecord err", err);
      } finally {
        this.loadingData = false;
      }
    },
    /**
     * 查询表单
     */
    onHandleSearch(e) {
      this.formData = e;
      this.formData.page = 1;
      this.ajaxGetTableData();
    },
    /**
     * 重置数据
     */
    onHandleRefresh() {
      this.formData = {
        ...this.formDataClone,
      };
      this.ajaxGetTableData();
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    /**
     * 修改了每页数据条数
     */
    onHandleSizeChange(val) {
      this.formData.page = 1;
      this.formData.pageSize = val;
      this.ajaxGetTableData();
    },
    /**
     * 修改了页码
     */
    onHandleCurrentChange(val) {
      this.formData.page = val;
      this.ajaxGetTableData();
    },
    /**
     * 退款弹窗
     */
    onHandleRefund(row) {
      this.$refs.refundDialog.onInitData(row);
    },
  },
};
</script>

<style lang="scss" scoped>
.ActivityGoldAccountDetails {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  .form {
    padding: 13px 15px;
  }
  .content-wrap {
    flex: 1;
    overflow-y: hidden;
  }
  .pagination {
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
